import { ILogObj, Logger } from "tslog"

const minLevelMap: { [key: string]: number } = {
    silly: 0,
    trace: 1,
    debug: 2,
    info: 3,
    warn: 4,
    error: 5,
    fatal: 6,
}

const defaultLevel: number = 3
const logLevel: number = minLevelMap[process.env.LOG_LEVEL?.toLowerCase() || "info"] ?? defaultLevel

export const log: Logger<ILogObj> = new Logger({ minLevel: logLevel })

export const formatError = (error: Error | unknown, printStack = process.env.NODE_ENV === "development") => {
    return printStack ? error : (error instanceof Error ? error.message : error)
}
